import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Avatar, Button, Fab, Grid, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useLocation, useNavigate } from 'react-router-dom';
import { ThemeContext } from '../../contexts/ThemeContext';
import Title from '../../Title';

export default function DashboardItem(props) {

  const { mode } = React.useContext(ThemeContext);
  const {image, title, request, action_lable, path} = props
  const navigate = useNavigate();

  const location = useLocation();

  return (
    <React.Fragment>
      <Grid item xs={12} md={4} lg={3}>
        <Paper
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            height: 240,
            ':hover': {
              backgroundColor: 'rgba(255, 172, 37, 0.16)',
            },
            position: 'relative',
          }}
        >
          <Avatar src={image} alt="texi" sx={{ width: 92, height: 92 }}/>
          <Title 
            sx={{
              margin: 'auto',
            }}>{title}</Title>
          <Grid container>
            <Typography component="p" variant="h4">
              {request || 0}
            </Typography>
            <Typography marginTop={'auto'} marginLeft={1} variant='body2'>Pending</Typography>
          </Grid>
          <div>
            <Button variant='text' sx={{ minHeight: 0, minWidth: 0, padding: 0, textDecoration: 'underline' }} onClick={()=>{ navigate(path) }}>
              {action_lable}
            </Button>
          </div>
          <Fab size="small" sx={{
            position: 'absolute',
            bottom: 10,
            right: 10
          }} 
          onClick={()=>{ navigate(path+"/add") }}
          color="primary" 
          aria-label="add">
            <AddIcon />
          </Fab>
        </Paper>
      </Grid>
    </React.Fragment>
  );
}
